export default __webpack_public_path__ + "static/media/Desser2.a55b32c5.svg";